if (!customElements.get('yc-wheel2')) {
  customElements.define('yc-wheel2', class YCWheel2 extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[data-tab-trigger]');
      this.contents = this.querySelectorAll('[data-tab-content]');
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.init();
    }

    init() {
      this.tabs.forEach(tab => {
        if (tab.classList.contains('active')) {
          this.currentIndex = parseInt(tab.dataset.tabTrigger, 10);
        }

        tab.addEventListener('click', () => {
          const index = tab.dataset.tabTrigger;
          this.switchTab(index, true);
        });
      });

      // Add touch events for mobile swiping
      const mainContent = this.querySelector('.yc-wheel2__main');
      if (mainContent) {
        mainContent.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
          this.touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });

        mainContent.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.touchEndY = e.changedTouches[0].screenY;
          this.handleSwipe();
        }, { passive: true });
      }
    }

    handleSwipe() {
      if (window.innerWidth > 768) return; // Only enable swipe on mobile

      const thresholdX = 50; // Minimum swipe distance horizontally
      const thresholdY = 50; // Maximum allowed vertical distance to still be considered a horizontal swipe
      const swipeDistanceX = this.touchEndX - this.touchStartX;
      const swipeDistanceY = this.touchEndY - this.touchStartY;

      if (Math.abs(swipeDistanceX) > thresholdX && Math.abs(swipeDistanceY) < thresholdY) {
        if (swipeDistanceX < 0) {
          // Swiped left, go to next
          this.nextTab();
        } else {
          // Swiped right, go to previous
          this.prevTab();
        }
      }
    }

    nextTab() {
      if (this.currentIndex < this.tabs.length - 1) {
        this.switchTab((this.currentIndex + 1).toString(), false);
      } else {
        this.switchTab("0", false);
      }
    }

    prevTab() {
      if (this.currentIndex > 0) {
        this.switchTab((this.currentIndex - 1).toString(), false);
      } else {
        this.switchTab((this.tabs.length - 1).toString(), false);
      }
    }

    switchTab(index, isClick = false) {
      this.currentIndex = parseInt(index, 10);

      this.tabs.forEach(tab => {
        tab.classList.toggle('active', tab.dataset.tabTrigger === index);
      });

      this.contents.forEach(content => {
        content.classList.toggle('active', content.dataset.tabContent === index);
      });
      
      if (window.innerWidth <= 768) {
        // Scroll the active tab into view horizontally
        const activeTab = this.querySelector(`[data-tab-trigger="${index}"]`);
        const tabsContainer = this.querySelector('.yc-wheel2__tabs');
        if (activeTab && tabsContainer) {
          const scrollLeft = activeTab.offsetLeft - tabsContainer.offsetLeft - (tabsContainer.offsetWidth / 2) + (activeTab.offsetWidth / 2);
          tabsContainer.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }

        // Scroll to top of content if triggered by click
        // if (isClick) {
        //   const main = this.querySelector('.yc-wheel2__main');
        //   if (main) {
        //     main.scrollIntoView({ behavior: 'smooth' });
        //   }
        // }
      }
    }
  });
}
